import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { SuspensionDetailModel } from 'src/app/models/rental/suspension-detail.model';
import { SuspensionModel } from 'src/app/models/rental/suspension.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { RentalStockTableModel } from 'src/app/models/tables/rental/rental-stock-table.model';
import { SuspensionDetailCaptureTableModel } from 'src/app/models/tables/rental/suspension-detail-register-table.model';
import { SuspensionDetailService } from 'src/app/services/rental/suspension-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-suspension-detail',
  templateUrl: './suspension-detail.component.html',
  styleUrls: ['./suspension-detail.component.scss'],
  standalone: false
})
export class SuspensionDetailComponent implements OnInit {

  @ViewChild('rentalStock') rentalStockModalComponent?: CustomModalComponent | null = null;
  @Input() disabledActions: boolean = false;
  @Input() disabledDetail: boolean = false;
  @Input() suspensionModel: SuspensionModel = new SuspensionModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  ascendantRentalStock: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortRentalStock: string | null = null;
  component = CustomTableSelectComponent;
  dataRentalStock: PagedResponseModel<RentalStockTableModel> = new PagedResponseModel<RentalStockTableModel>();
  detailData: PagedResponseModel<SuspensionDetailCaptureTableModel> = new PagedResponseModel<SuspensionDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = false;
  filtersRentalStock: ColumnResponseModel[] = []
  headerRentalStock: ColumnResponseModel[] = [];
  inputsForRentalStock$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: [],

  })
  isFormView: boolean = false;
  limit: number = 10;
  limitRentalStock: number = 5;
  suspensionDetails: SuspensionDetailModel[] = [];
  output$ = new Subject<any>();
  page: number = 1;
  pageRentalStock: number = 1;
  subscription: Subscription;
  suspensionDetail: SuspensionDetailModel = new SuspensionDetailModel();
  tableActions: TableAction[] = [];

  constructor(private suspensionDetailService: SuspensionDetailService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit() {
    await this.getColumnsForDetailCapture();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeRentalStock(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const suspensionModel = changes["suspensionModel"];
    if (suspensionModel && !suspensionModel.firstChange) {
      this.getFormView(false);
      this.getSuspensionDetailsBySuspension();
    }
    this.disabledButton = this.disabledDetail || this.suspensionModel.suspensionId == 0 ? true : false;
    const disabledActions = changes["disabledActions"];
    if (disabledActions) {
      this.tableActions = this.disabledDetail ? [] : this.getDefaultActions();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async deleteSuspensionDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle de la suspensión?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.suspensionDetailService.deleteSomeDetails(selectedIds, this.suspensionModel.suspensionId));
        this.toastHandlerService.showToast('success', 'El detalle de la suspensión fue eliminado exitosamente.', '');
        this.clearSelectionTrigger++;
        this.getUpdateListDetailByDelete();
      } catch (error) {
        console.error('Error while deleting the suspension detail.', error);
      }
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  async getColumnsForDetailCapture() {
    try {
      this.detailHeader = await firstValueFrom(this.suspensionDetailService.getColumnsForDetailCapture());
    } catch (error) {
      console.error('Error to getting the columns for the query.', error);
    }
  }

  async getColumnsRentalStock() {
    try {
      if (this.headerRentalStock.length === 0) {
        this.headerRentalStock = await firstValueFrom(this.suspensionDetailService.getColumnsForStocksInCostCenter());
      }
    } catch (error) {
      console.error('Error while getting the columns for the query.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getStocksInCostCenterForSuspensionId() {
    try {
      this.dataRentalStock = await firstValueFrom(this.suspensionDetailService.getStocksInCostCenterForSuspensionId(this.pageRentalStock,
        this.limitRentalStock, this.columnSortRentalStock, this.ascendantRentalStock, this.suspensionModel.suspensionId, this.filtersRentalStock));
      this.updateInputs();
    } catch (error) {
      console.error('Error while getting the list of articles in stock.', error);
    }
  }

  async getSuspensionDetailsBySuspension() {
    try {
      this.detailData = await firstValueFrom(this.suspensionDetailService.getSuspensionDetailsBySuspension(this.page, this.limit,
        this.columnSort, this.ascendant, this.suspensionModel.suspensionId));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error while getting the suspension details.', error);
    }
  }

  async getSuspensionDetailByKeys(articleId: number, storeId: number): Promise<SuspensionDetailModel> {
    try {
      return await firstValueFrom(this.suspensionDetailService.getSuspensionDetailByKeys(this.suspensionModel.suspensionId,
        articleId, storeId));
    } catch (error) {
      console.error('Error al obtener el detalle de la suspensión.', error);
      throw error;
    }
  }

  getUpdateListDetailByDelete() {
    this.clearSelectionTrigger++;
    this.getSuspensionDetailsBySuspension();
  }

  async onAction(event: { action: string, item?: SuspensionDetailModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.suspensionDetailService.getSuspensionDetailById(event.item!.suspensionDetailId));
      if (response)
        this.suspensionDetail = response;
      this.getFormView(true);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteSuspensionDetail(event.selectedItems);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersRentalStock = this.removeDuplicates(filters);
    this.filtersRentalStock.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openModal() {
    this.filtersRentalStock = [];
    await Promise.all([
      this.getColumnsRentalStock(),
      this.getStocksInCostCenterForSuspensionId()
    ]);
    this.updateInputs();
    this.rentalStockModalComponent && this.rentalStockModalComponent.show();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getSuspensionDetailsBySuspension();
  }

  async onPageChangeRentalStock(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageRentalStock = event.page;
    this.limitRentalStock = event.pageSize;
    this.columnSortRentalStock = event.sortField || null;
    this.ascendantRentalStock = event.sortOrder === 1;
    this.getStocksInCostCenterForSuspensionId();
  }

  async handleSelectedItems(selectedItems: any) {
    const defaultDays = (this.suspensionModel.days && this.suspensionModel.days > 0) ? this.suspensionModel.days : 1;
    if (selectedItems.length == 1) {
      const { articleId, storeId, stock } = selectedItems[0];
      const response = await this.getSuspensionDetailByKeys(articleId, storeId);
      if (response.suspensionDetailId === 0) {
        this.suspensionDetail = new SuspensionDetailModel();
        this.suspensionDetail.suspensionId = this.suspensionModel.suspensionId;
        this.suspensionDetail.articleId = articleId;
        this.suspensionDetail.storeId = storeId;
        this.suspensionDetail.quantity = stock;
        this.suspensionDetail.days = defaultDays;
      } else {
        this.suspensionDetail = response;
      }
    } else {
      const newDetails: SuspensionDetailModel[] = [];
      selectedItems.forEach((element: { articleId: number; storeId: number; stock: number }) => {
        const newSuspensionDetail = new SuspensionDetailModel();
        newSuspensionDetail.suspensionId = this.suspensionModel.suspensionId;
        newSuspensionDetail.articleId = element.articleId;
        newSuspensionDetail.storeId = element.storeId;
        newSuspensionDetail.quantity = element.stock;
        newSuspensionDetail.days = defaultDays;
        newDetails.push(newSuspensionDetail);
      });
      this.suspensionDetails = newDetails;
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersRentalStock = this.filtersRentalStock.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersRentalStock.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  updateInputs() {
    this.inputsForRentalStock$.next({
      headers: this.headerRentalStock,
      data: this.dataRentalStock,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersRentalStock,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]

    });
  }
}
